import { place, type RoomContext, type RoomDecorator } from '../index';
import * as kit from '../../castle-kit';
import * as g from '../../castle-kit-grounds';

/**
 * NORTH RAMPART (Северный обход) — the open-air WALL-WALK along the castle's high north wall: long + thin,
 * wind-swept and SPARSE. The HERO is the unbroken row of CRENELLATIONS crowning the whole north edge so the
 * parapet reads as a real battlement against the open sky. Brazier watch-fires pool warm light down the walk
 * at even intervals; three tall heraldic banners snap in the wind on their poles; two rampart benches let a
 * sentry rest and look out. Composition is deliberately empty between the accents — cold open stone IS the
 * design, the chain of braziers the only warmth on a sky-open beat.
 *
 * Geometry: zone (360,40) 2880×320 → centre (1800,200). Doors on the S edge (many, to the rooms below) +
 * to the corner towers at the W/E ends are kept clear — all dressing rides the NORTH parapet + the floor.
 */
const decorate: RoomDecorator = (ctx: RoomContext) => {
  const { art } = ctx;

  // ── HERO: the crenellated parapet — a repeating merlon row crowning the whole north (top) edge. ──
  for (const cxx of [460, 700, 940, 1180, 1420, 1660, 1900, 2140, 2380, 2620, 2900, 3140]) {
    place(ctx, g.crenellation(art, 200), cxx, 70);
  }

  // ── SEATS: rampart benches (sit-able) for the watch to rest against the wall. ──
  place(ctx, g.gardenBench(art, 96), 700, 200);
  place(ctx, g.gardenBench(art, 96), 2900, 200);

  // ── POOL LIGHT: brazier watch-fires spaced along the walk — the only warmth on the open wall. ──
  for (const bx of [520, 1160, 2440, 3080]) {
    place(ctx, kit.brazier(art), bx, 200);
  }

  // ── Tall heraldic banners on poles, snapping in the wind above the parapet line. ──
  place(ctx, kit.banner(art, 0x8a2f2f, 120), 900, 160);
  place(ctx, kit.banner(art, undefined, 130), 1800, 160);
  place(ctx, kit.banner(art, 0x2f4a8a, 120), 2700, 160);
};

export default decorate;
